import {Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import {DateUtils} from "../../modules/admin/shared/helpers/date-utils";
import {SponsorsService} from "@portal/api/sponsors-service";
import {catchError, map, of} from "rxjs";
import {CollaboratorResponse} from "@portal/api/responses/collaborators/collaborator-response";
import {SponsorsReportRequest} from "@portal/api/requests/sponsors/sponsors-report-request";
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix, MatInput } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDateRangePicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-sponsors-report-modal',
    templateUrl: './sponsors-report-modal.component.html',
    styleUrls: ['./sponsors-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatCheckbox, MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatSuffix, MatDateRangePicker, MatInput, MatDialogActions, MatButton, MatDialogClose]
})
export class SponsorsReportModalComponent implements OnInit {
    selectedOptions: number[] = [];
    startDate: Date;
    endDate: Date;
    maxValue: number = null;
    minValue: number = null;
    selectedCollaboratorId: string;
    selectedSortBy: string = 'name';
    options: { label: string, value: string }[] = [];
    isUsersDropdownLoading: boolean;

    constructor(
        public dialogRef: MatDialogRef<SponsorsReportModalComponent>,
        private readonly _sponsorService: SponsorsService) {

    }

    ngOnInit() {
        this.loadOptions();
        this.selectedCollaboratorId = '';
    }

    loadOptions() {
        this.isUsersDropdownLoading = true;
        this._sponsorService.getCollaborators().pipe(
            catchError(() => of([])),
            map((response: CollaboratorResponse[]) =>
                response.map(option => ({label: `${option.name}`, value: option.id.toString()}))
            )
        ).subscribe(
            (options) => {
                this.options = [...this.options, ...options];
            },
            () => {
                // Handle the error state if needed here
                this.isUsersDropdownLoading = false;
            },
            () => {
                this.options = this.options.filter((option, index) => {
                    return this.options.findIndex((otherOption) => {
                        return option.value === otherOption.value;
                    }) === index;
                });

                this.options = this.options.sort((a, b) => {
                    if (a.label.toLocaleUpperCase() < b.label.toLocaleUpperCase()) {
                        return -1;
                    }
                    if (a.label.toLocaleUpperCase() > b.label.toLocaleUpperCase()) {
                        return 1;
                    }
                    return 0;
                });
                this.isUsersDropdownLoading = false;
            }
        );
    }


    confirmSelection() {
        let result = {
            hasPaidListing: this.selectedOptions[2] ?? false,
            hasPromisedListing: this.selectedOptions[3] ?? false,
            hasToContactListing: this.selectedOptions[4] ?? false,
            hidePaidValue: this.selectedOptions[5] ?? false,
            filterByDates: this.selectedOptions[6] ?? false,
            startDate: !this.startDate ? null : DateUtils.momentDateToString(this.startDate),
            endDate: !this.endDate ? null : DateUtils.momentDateToString(this.endDate),
            collaboratorId: this.selectedCollaboratorId === "" ? null : this.selectedCollaboratorId,
            valuesInterval: this.selectedOptions[7] ?? false,
            minValue: this.minValue,
            maxValue: this.maxValue,
            onlyWithPublicity: this.selectedOptions[8] ?? false,
            sortBy: this.selectedSortBy,
        } as SponsorsReportRequest;

        this.dialogRef.close(result);
    }

    onSelectChange(value: any) {
        this.selectedCollaboratorId = value;
    }
}
